import { Observable, timer } from 'rxjs';

import {
  ExtensionApiFactory,
  Manifest,
  setApiStrategy,
  setLocalOverrides,
} from '~cdw-ae/common/frontend/browser-extension-api';

import AlertService from './services/alerts/alerts-service';
import CheckInService from './services/check-in/check-in.service';
import CustomerService from './services/customer/customer.service';
import DeviceService from './services/device/device.service';
import { rootStore } from './services/extension-store/extension.store';
import { setLoaded } from './services/extension-store/global-flags.store';
import { DeviceManagedState } from './services/extension-store/interfaces/extension-store.interfaces';
import LicensingService from './services/licensing/licensing.service';
import MessageHandlerService from './services/message-handler/message-handler.service';
import NetworkStatusService from './services/network-status/network-status.service';
import OfflineSyncService from './services/offlineSync/offline-sync.servce';
import PubsubService from './services/pubsub/pubsub.service';
import UpdateSessionService from './services/update-session/update-session.service';
import UserActivityService from './services/user-activity/user-activity.service';
import UserProfileService from './services/user-profile/user-profile.service';
import UtilsSerice from './services/utils/utils.service';
import VersionUpdateService from './services/version-update/version-update.service';

import { environment, RuntimeEnvironment } from '../environments/environment';

// Initialize the Extension API. This will set this Globally.
console.log('Extension API Strategy:', environment.extensionApiStrategy);
setApiStrategy(environment.extensionApiStrategy);
if (environment.environment === RuntimeEnvironment.LOCAL) {
  setLocalOverrides(environment.localApiOverrides);
}

const extensionApi = ExtensionApiFactory();

const appLoadedTrigger: Observable<number> = timer(30 * 1000, 120 * 1000);

const ServiceWorkerInit = async () => {
  const manifestData: Manifest = extensionApi.getManifest();

  console.log('Gopher Buddy Service Worker');
  console.log('Environment:', environment.environment);
  console.log('Extension Version:', manifestData.version);
  rootStore.subscribe(async () => {
    const appState = rootStore.getState();
    UtilsSerice.debugLog('State update');
    UtilsSerice.debugLog(appState);
  });

  await AlertService.init()
    .then(UserProfileService.init)
    .then(DeviceService.init)
    .then(NetworkStatusService.init)
    .then(MessageHandlerService.init)
    .then(DeviceService.setManagedStatus)
    .catch((error) => console.error('Error starting managed services', error));

  if (rootStore.getState().globalAppFlagsState.deviceManagedState === DeviceManagedState.MANAGED) {
    await PubsubService.init(environment.pubsubConfig)
      .then(UserActivityService.init)
      .then(LicensingService.init)
      .then(CustomerService.init)
      .then(CheckInService.init)
      .then(UpdateSessionService.init)
      .then(VersionUpdateService.init)
      .then(OfflineSyncService.init)
      .catch((error) => console.error('Error starting additional Services', error));
  }

  console.log('Extension Init Complete');
  rootStore.dispatch(setLoaded());
};

// Run specific actions when the extension is installed, upodated, or chrome browser/OS  has been updated
extensionApi.onInstalled(async () => {
  await ServiceWorkerInit();
});

// Run specific actions when the Browser/OS is started
extensionApi.onStartup(async () => {
  await ServiceWorkerInit();
});

// Sometimes there is a state where onStartup and onInstalled is not triggered
// This is a fallback to ensure the extension is loaded
appLoadedTrigger.subscribe(async () => {
  const appState = rootStore.getState();
  if (appState.globalAppFlagsState.isLoaded) {
    UtilsSerice.debugLog('App Already Loaded');
    return;
  }
  await ServiceWorkerInit();
});
